import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { map } from 'rxjs/operators';
import { AuthService } from '../Services/auth.service';
import { Permissions } from '../../../Enums/permission.enum';
import { isModeratorCreateBlocked, stripTrailingAddSegment } from '../Services/moderator-create.util';

export const moderatorCreateGuard: CanActivateFn = (route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);

  const settingKey = route.data['settingKey'] as
    | 'moderator_can_create_applications'
    | 'moderator_can_create_groups';
  const bypassPermission = route.data['bypassPermission'] as Permissions;

  return authService.initializeAuth().pipe(
    map(() => {
      const user = authService.getCurrentUser();
      if (!isModeratorCreateBlocked(user, settingKey, bypassPermission)) {
        return true;
      }
      return router.createUrlTree([stripTrailingAddSegment(state.url)]);
    }),
  );
};
